import { storage } from "@/api/firebase/firebase.config";

/**
 * Uploads an image file to a specified location in cloud storage and returns the download URL.
 *
 * @param file - The image file to be uploaded.
 * @param location - The storage location path where the file will be uploaded.
 * @returns A promise that resolves to the download URL of the uploaded image.
 * @throws Will throw an error if no file is provided or if the upload process fails.
 */

export const uploadImage = async (
  file: File,
  location: string
): Promise<string> => {
  if (!file) {
    throw new Error("No file provided for upload.");
  }

  const storageRef = storage.ref(`${location}/${file.name}`);

  try {
    await storageRef.put(file);

    const downloadURL = await storageRef.getDownloadURL();

    // Replace the firebase URL with ImageKit.io URL-endpoint
    const imageKitURL = downloadURL.replace(
      "https://firebasestorage.googleapis.com/v0/b/spike-ba886.firebasestorage.app/o",
      "https://ik.imagekit.io/iplay/SPIKE"
    );

    return imageKitURL;
  } catch (error) {
    if (error instanceof Error) {
      throw new Error(`Failed to upload image: ${error.message}`);
    } else {
      throw new Error("Failed to upload image due to an unknown error.");
    }
  }
};
